export default __webpack_public_path__ + "static/media/BMWLanding.d0552bcb.png";